import IconAsMaskImage from '../IconAsMaskImage'

function Attachment({ pureSvg, className, ...rest }) {
  const svg = (
    <svg {...rest} width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <rect width="40" height="40" rx="20" fill="#830070" />
      </g>
      <path
        opacity="0.4"
        d="M21.5 10.5C21.5 11.3284 20.8284 12 20 12C19.1716 12 18.5 11.3284 18.5 10.5C18.5 9.67157 19.1716 9 20 9C20.8284 9 21.5 9.67157 21.5 10.5Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M27 23V21C27 18.1716 27 16.7574 26.1213 15.8787C25.2426 15 23.8284 15 21 15H19C16.1716 15 14.7574 15 13.8787 15.8787C13 16.7574 13 18.1716 13 21V23C13 25.8284 13 27.2426 13.8787 28.1213C14.7574 29 16.1716 29 19 29H21C23.8284 29 25.2426 29 26.1213 28.1213C27 27.2426 27 25.8284 27 23Z"
        fill="white"
      />
      <path
        d="M27 23V21C27 18.1716 27 16.7574 26.1213 15.8787C25.2426 15 23.8284 15 21 15H19C16.1716 15 14.7574 15 13.8787 15.8787C13 16.7574 13 18.1716 13 21V23C13 25.8284 13 27.2426 13.8787 28.1213C14.7574 29 16.1716 29 19 29H21C23.8284 29 25.2426 29 26.1213 28.1213C27 27.2426 27 25.8284 27 23Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M27 25C28.4142 25 29.1213 25 29.5607 24.5607C30 24.1213 30 23.4142 30 22C30 20.5858 30 19.8787 29.5607 19.4393C29.1213 19 28.4142 19 27 19"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M13 25C11.5858 25 10.8787 25 10.4393 24.5607C10 24.1213 10 23.4142 10 22C10 20.5858 10 19.8787 10.4393 19.4393C10.8787 19 11.5858 19 13 19"
        stroke="white"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M21.5 10.5C21.5 11.3284 20.8284 12 20 12C19.1716 12 18.5 11.3284 18.5 10.5C18.5 9.67157 19.1716 9 20 9C20.8284 9 21.5 9.67157 21.5 10.5Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path d="M20 12V15" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M17 20V21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23 20V21" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18 24.5C18 24.5 18.6667 25 20 25C21.3333 25 22 24.5 22 24.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <defs>
        <filter
          id="filter0_i_8509_5703"
          x="0"
          y="-16.625"
          width="40"
          height="56.625"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-25" />
          <feGaussianBlur stdDeviation="8.3125" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 0.6375 0 0 0 0 0.00796875 0 0 0 0 0.543319 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_8509_5703" />
        </filter>
      </defs>
    </svg>
  )

  if (pureSvg) return svg

  return <IconAsMaskImage {...{ svg, className }} />
}

export default Attachment
